<template>
    <div class="busca" id="tour-search">
        <div class="input-icon">
            <i class="fa-solid fa-magnifying-glass icon-search"></i>
            <input 
              type="text" 
              v-model="search" 
              @keyup.enter="executeGlobalSearch"
              placeholder="Busque o que você procura (Pressione Enter para busca profunda)" 
              class="search-input" 
            />
        </div>

        <div class="filtros">
            <form @submit.prevent>
                <!-- Filtros -->
            </form>
        </div>
    </div>
</template>

<script>
import '../styles/Search.css';

export default {
    name: 'Search',
    data() {
        return {
            search: '',
        };
    },
    watch: {
        search() {
            this.emitirFiltro();
        },
    },
    methods: {
        emitirFiltro() {
            this.$emit('filtro-atualizado', {
                texto: this.search,
            });
        },
        executeGlobalSearch() {
            if(this.search.trim() !== '') {
                this.$router.push({ name: 'SearchResults', query: { q: this.search } }).catch(err => {
                    // Ignore NavigationDuplicated se já estiver na página
                    if (err.name !== 'NavigationDuplicated') throw err;
                });
            }
        }
    },
};
</script>